import { Component } from "@angular/core";
import { XOField } from './xo-field.component';

@Component({
    selector: "xo-field-fraction",
    templateUrl: "./xo-field-fraction.component.html"
})
export class XOFieldFraction extends XOField {
}
